import Utils from "@/utils/utils"

export const DEPLOYING_TIMER = Utils.minutes(12)
export const ARCHIVING_TIMER = Utils.minutes(5)
export const RESTORING_TIMER = Utils.minutes(13)
export const STARTING_TIMER = Utils.seconds(15)
export const STOPPING_TIMER = Utils.seconds(18)
export const DESTROYING_TIMER = Utils.minutes(5)
